"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent, networkId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.networkId = networkId;
    }
    path(withParameter = true) {
        if (withParameter && this.networkId !== null) {
            return `${this.parent.path()}/networks/${this.networkId}`;
        }
        return `${this.parent.path()}/networks`;
    }
    /**
     * Returns a corporate network map with emergency addresses assigned
   * to the current account.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new network in a corporate ethernet map for assignment
   * of emergency addresses to network access points.
   *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async post(createNetworkRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createNetworkRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the specified network with emergency addresses assigned
   * to the current account.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async get(restRequestConfig) {
        if (this.networkId === null) {
            throw new Error('networkId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a network in a corporate ethernet map for assignment of emergency
   * addresses to network access points.
   *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async put(updateNetworkRequest, restRequestConfig) {
        if (this.networkId === null) {
            throw new Error('networkId must be specified.');
        }
        const r = await this.rc.put(this.path(), updateNetworkRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes network(s) in a corporate ethernet map for Automatic Location
   * Updates feature.
   *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async delete(restRequestConfig) {
        if (this.networkId === null) {
            throw new Error('networkId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map